import React from 'react'
import LaptopURL from '../../assets/images/Laptop.png';
import jemibLogoUrl from '../../assets/logos/jemib-logo-white.svg';
import instagramLogoUrl from '../../assets/logos/instagram.svg';
import facebookLogoUrl from '../../assets/logos/facebook.svg';
import linkedinLogoUrl from '../../assets/logos/linkedin.svg';
import tiktokLogoUrl from '../../assets/logos/tiktok.svg';
import twitterLogoUrl from '../../assets/logos/twitter.svg';
import { useInViewOnce } from '../../Utilities/Observer';

const Contatti = () => {
    const [ref, visible] = useInViewOnce();

  return (
    <section id='contatti' className='w-screen bg-brand-darkgray px-6 md:px-8 xl:px-[8vw] py-12 sm:py-16 lg:py-24'>
        <article ref={ref} className={`transition-all duration-500 ease-out 
          ${visible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
            <p className='font-mono text-brand-blue uppercase'>// contacts</p>
            <h2 className='uppercase text-brand-white font-display font-black text-5xl sm:text-[clamp(2.4rem,6vw,6.5rem)] leading-none'>GET IN TOUCH</h2>
        </article>

        <section className='grid md:grid-cols-2 gap-12 xl:gap-32 mt-12'>
            <img src={LaptopURL} className='rounded-md' alt="Reply laptop image" />
            <article>
                <img src={jemibLogoUrl} alt="Jemib logo" className='w-32'/>

                <div className='py-6'>
                    <p className='text-md text-brand-white font-mono'>Do you have any questions for us?</p>
                    <h5 className='text-brand-blue font-display text-2xl font-medium underline py-4'>studentclash@jemib.it</h5>
                </div>

                <div className='md:pb-6'>
                    <p className='text-md text-brand-white font-mono'>Follow the latest news about the event on our social channels</p>
                    <div className='flex gap-6 mt-6'>
                        <div className='w-12 h-12 lg:w-16 lg:h-16 p-3 border-2 border-brand-white hover:border-brand-blue hover:scale-105 duration-200 rounded-md'>
                            <a href="https://www.instagram.com/jemib_bicocca/" target="_blank" rel="noopener noreferrer"><img className='w-full' src={instagramLogoUrl} alt="Instagram logo"/></a>
                        </div>
                        <div className='w-12 h-12 lg:w-16 lg:h-16 p-3 aspect-square border-2 border-brand-white hover:border-brand-blue hover:scale-105 duration-200 rounded-md'>
                            <a href="https://www.linkedin.com/company/jemib---junior-enterprise-milano-bicocca/" target="_blank" rel="noopener noreferrer"><img className='w-full' src={linkedinLogoUrl} alt="LinkedIn logo"/></a>
                        </div>
                        <div className='w-12 h-12 lg:w-16 lg:h-16 p-3 aspect-square border-2 border-brand-white hover:border-brand-blue hover:scale-105 duration-200 rounded-md'>
                            <a href="https://www.tiktok.com/@jemib_bicocca" target="_blank" rel="noopener noreferrer"><img src={tiktokLogoUrl} alt="TikTok logo" className='w-full'/></a>
                        </div>
                    </div>
                </div>

                <div className='md:py-6 pt-4'>
                    <p className='text-md text-brand-white font-mono'>Follow Reply's social channels too</p>
                    <div className='flex gap-6 mt-6'>
                        <div className='w-12 h-12 lg:w-16 lg:h-16 p-3 border-2 border-brand-white hover:border-brand-blue hover:scale-105 duration-200 rounded-md'>
                            <a href="https://www.instagram.com/replyulabs/" target="_blank" rel="noopener noreferrer"><img className='w-full' src={instagramLogoUrl} alt="Instagram logo"/></a>
                        </div>
                        <div className='w-12 h-12 lg:w-16 lg:h-16 p-3 aspect-square border-2 border-brand-white hover:border-brand-blue hover:scale-105 duration-200 rounded-md'>
                            <a href="https://www.linkedin.com/company/reply/" target="_blank" rel="noopener noreferrer"><img className='w-full' src={linkedinLogoUrl} alt="LinkedIn logo"/></a>
                        </div>
                        <div className='w-12 h-12 lg:w-16 lg:h-16 p-3 aspect-square border-2 border-brand-white hover:border-brand-blue hover:scale-105 duration-200 rounded-md'>
                            <a href="https://www.facebook.com/ReplyUlabs/" target="_blank" rel="noopener noreferrer"><img className='w-full' src={facebookLogoUrl} alt="Facebook logo"/></a>
                        </div>
                        <div className='w-12 h-12 lg:w-16 lg:h-16 p-3 aspect-square border-2 border-brand-white hover:border-brand-blue hover:scale-105 duration-200 rounded-md'>
                            <a href="https://twitter.com/replyulabs?lang=en" target="_blank" rel="noopener noreferrer"><img className='w-full' src={twitterLogoUrl} alt="Twitter logo"/></a>
                        </div>
                    </div>
                </div>
            </article>
        </section>

        <article className='flex md:justify-center mt-12 md:mt-12'>
            <button className='transparent-btn px-12 py-4'> 
                <a href="#iscriviti" className='text-nowrap'>[ REGISTER YOUR TEAM NOW ] </a>
            </button>
        </article>
    </section>
  )
}

export default Contatti